import { EmployeeProvider } from "../../context/EmployeeContext";
import { useEffect, useState } from "react";
import EmpSidebar from "./EmpSidebar";
import EmpTopbar from "./EmpTopbar";
import EmpDashboardView from "./EmpDashboardView";
import EmpProfileSection from "./EmpProfileSection";
import EmpAttendanceWidget from "./EmpAttendanceWidget";
import EmpLeaveSummaryWidget from "./EmpLeaveSummaryWidget";
import EmpPayrollPage from "./EmpPayrollPage";
import EmpAssetsPage from "./EmpAssetsPage";
import EmpTimelinePage from "./EmpTimelinePage";
import EmpNotificationsPage from "./EmpNotificationsPage";
import EmpChatPage from "./EmpChatPage";
import EmpHelpDeskPage from "./EmpHelpDeskPage";
import EmpPoliciesPage from "./EmpPoliciesPage";
import EmpPerformancePage from "./EmpPerformancePage";
import EmpCalendarPage from "./EmpCalendarPage";
import EmpSettingsPage from "./EmpSettingsPage";
import EmpNotesPage from "./EmpNotesPage";
import EmpPeoplePage from "./EmpPeoplePage";
import EmpOffboardingPage from "./EmpOffboardingPage";
import { Icons } from "../../components/common/Icons";
import { useEmployeeData } from "../../context/EmployeeContext";
import { formatDateOnly } from "../../utils/helpers";
import EmployeeDocumentDashboard from "../../components/common/EmployeeDocumentDashboard";
import '../../assets/styles/employee.css';

import api from "../../services/api";import "../../assets/styles/Employee/EmployeeDashboard.css";

function EmpPageView({ active, user, onNav }) {
  const { empChecklist, empOnboardDocs, empInitPermReqs, empPermBalance, refreshEmployeeData } = useEmployeeData();

  const handleDocDownload = async (doc) => {
    try {
      if (doc.id) {
        await api.downloadDocById(doc.id, doc.name || doc.doc_name || 'document');
      } else {
        alert('Document download not available');
      }
    } catch (e) {alert('Download failed: ' + e.message);}
  };

  switch (active) {
    case "dashboard":return <EmpDashboardView user={user} />;
    case "profile":return <><div className="section-label">My Profile</div><EmpProfileSection /></>;
    case "onboarding":return <><div className="section-label">Onboarding & Employment</div><div className="mb-24"><EmployeeDocumentDashboard docs={empOnboardDocs} onRefresh={refreshEmployeeData} /></div><div className="mb-24"><div className="card animate-in"><div className="card-header"><div className="card-title">All Uploaded Documents</div></div><div className="card-body">{empOnboardDocs.length === 0 ? <div className="employeedashboard-inline-1">No documents found</div> : empOnboardDocs.map((d, i) => <div className="doc-item" key={i}><div className="doc-name">📄 {d.name || d.doc_name || 'Document'}</div><div className="doc-download employeedashboard-inline-2" onClick={() => handleDocDownload(d)}><Icons.Download /> Download</div></div>)}</div></div></div></>;
    case "offboarding":return <><div className="section-label">Offboarding</div><EmpOffboardingPage /></>;
    case "attendance":return <><div className="section-label">Attendance</div><EmpAttendanceWidget /></>;
    case "leave":return <><div className="section-label">Leave Summary</div><EmpLeaveSummaryWidget />
      {/* Permission Requests */}
      <div className="card animate-in employeedashboard-inline-3">
        <div className="card-header">
          <div className="card-title">Permission Requests</div>
          {empPermBalance && <div className="card-subtitle">{empPermBalance.used}h used / {empPermBalance.total}h total this month</div>}
        </div>
        <div className="card-body">
          {!empInitPermReqs || empInitPermReqs.length === 0 ?
            <div className="employeedashboard-inline-4">No permission requests yet</div> :

            <div className="employeedashboard-inline-5">
              {empInitPermReqs.map((p, i) =>
              <div key={i} className="employeedashboard-inline-6">
                  <div>
                    <div className="employeedashboard-inline-7">{formatDateOnly(p.date)}</div>
                    <div className="employeedashboard-inline-8">{p.fromTime} — {p.toTime} ({p.hours}h) · {p.reason}</div>
                  </div>
                  <div className="employeedashboard-inline-9">
                    {p.pmStatus && <span style={{ "--employeedashboard-1-background": p.pmStatus === 'approved' ? '#eff6ff' : p.pmStatus === 'rejected' ? '#fef2f2' : '#fef3c7', "--employeedashboard-1-color": p.pmStatus === 'approved' ? '#1d4ed8' : p.pmStatus === 'rejected' ? '#dc2626' : '#d97706' }} className="employeedashboard-dyn-1">PM: {p.pmStatus}</span>}
                    <span className={`status-badge ${p.status}`}><span className="sb-dot" />{p.status}</span>
                  </div>
                </div>
              )}
            </div>
            }
        </div>
      </div>
      <div className="employeedashboard-inline-10"><EmpAttendanceWidget showActions /></div></>;
    case "payroll":return <><div className="section-label">Payroll & Payslips</div><EmpPayrollPage /></>;
    case "assets":return <><div className="section-label">My Assets</div><EmpAssetsPage /></>;
    case "timeline":return <><div className="section-label">Employee Timeline</div><EmpTimelinePage /></>;
    case "calendar":return <><div className="section-label">Calendar & Events</div><EmpCalendarPage /></>;
    case "announcements":return <><div className="section-label">Notifications</div><EmpNotificationsPage onNavigate={onNav} /></>;
    case "chat":return <><div className="section-label">Chat</div><EmpChatPage user={user} /></>;
    case "helpdesk":return <><div className="section-label">Help Desk</div><EmpHelpDeskPage /></>;
    case "policies":return <><div className="section-label">Company Policies</div><EmpPoliciesPage /></>;
    // case "performance":return <><div className="section-label">Performance</div><EmpPerformancePage /></>;
    case "notes":return <><div className="section-label">My Notes</div><EmpNotesPage /></>;
    case "people":return <><div className="section-label">People Directory</div><EmpPeoplePage /></>;
    case "settings":return <><div className="section-label">Settings</div><EmpSettingsPage /></>;
    default:return <EmpDashboardView user={user} />;
  }
}

function EmployeeDashboardInner({ onLogout, user }) {
  const [active, setActive] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [offboardingOnly, setOffboardingOnly] = useState(false);
  const [noticeBanner, setNoticeBanner] = useState('');
  const [autoOffboardingApplied, setAutoOffboardingApplied] = useState(false);

  const safeSetActive = (view) => {
    if (offboardingOnly && view !== 'offboarding') {
      setActive('offboarding');
      return;
    }
    setActive(view);
  };

  const detectOffboardingOnly = async () => {
    try {
      const rows = await api.getEmployeeLifecycleRequests('offboarding');
      const list = Array.isArray(rows) ? rows : [];
      const only = list.some((r) => !!r.final_settlement_sent_at || String(r.status || '').toLowerCase() === 'settlement_sent');
      setOffboardingOnly(only);
      // Force redirect only in strict offboarding-only mode and only once.
      if (only && !autoOffboardingApplied && active !== 'offboarding') {
        setActive('offboarding');
        setAutoOffboardingApplied(true);
      }
      const notice = list.find((r) => String(r.status || '').toLowerCase() === 'notice_period' && r.notice_start_date && r.notice_end_date);
      setNoticeBanner(notice ? `You are under notice period: ${notice.notice_start_date} to ${notice.notice_end_date} (${notice.notice_duration || '-'} days)` : '');
    } catch {
      setOffboardingOnly(false);
      setNoticeBanner('');
    }
  };

  useEffect(() => {detectOffboardingOnly();}, []);
  useEffect(() => {
    if (offboardingOnly && active !== 'offboarding') setActive('offboarding');
  }, [offboardingOnly, active]);

  return (
    <div className={`app-layout ${sidebarOpen ? "sb-open" : "sb-collapsed"}`}>
      <div className="sidebar-hotzone" onMouseEnter={() => setSidebarOpen(true)} />
      <button
        type="button"
        className="sidebar-peek"
        onMouseEnter={() => setSidebarOpen(true)}
        aria-label={sidebarOpen ? "Hide menu" : "Show menu"}
      >
        {sidebarOpen ? "‹" : "›"}
      </button>
      <EmpSidebar
        active={active}
        setActive={safeSetActive}
        onLogout={onLogout}
        user={user}
        offboardingOnly={offboardingOnly}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />
      <div className="main-wrapper">
        <EmpTopbar active={active} setActive={safeSetActive} onLogout={onLogout} user={user} offboardingOnly={offboardingOnly} />
        <div className="main-content" key={active}>
          {noticeBanner ?
          <div className="employeedashboard-inline-11">
              {noticeBanner}
            </div> :
          null}
          <EmpPageView active={active} user={user} onNav={safeSetActive} />
        </div>
      </div>
    </div>);

}

export default function EmployeeDashboard(props) {
  return <EmployeeProvider><EmployeeDashboardInner {...props} /></EmployeeProvider>;
}
